module.exports = __webpack_public_path__ + "img/iconZiDianLieBiao.68349485.svg";